import { Component } from '@angular/core';
import { AuthService } from '../../../Shared/Services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { Router } from '@angular/router';
import { UserType } from '../../../Shared/Enums/UserType';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ClientType } from '../../../Shared/Enums/ClientType';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { ClientService } from '../../../Services/client.service';
import { SharedService } from '../../../Shared/Services/shared.service';

@Component({
  selector: 'app-create-client-popup',
  templateUrl: './create-client-popup.component.html',
  styleUrl: './create-client-popup.component.scss'
})
export class CreateClientPopupComponent {
  form!: FormGroup;
  hidePassword = true;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private router: Router, private auth: AuthService, private api: ClientService,
    private dialogRef: MatDialogRef<CreateClientPopupComponent>, private shared: SharedService,
    private spinner: NgxSpinnerService, private toastrService: CustomToastrService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.initForm();
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  get f() {
    return this.form.controls;
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl('', [Validators.required]),
      clientPhone: new FormControl('', [Validators.required, Validators.minLength(11), Validators.pattern(/^-?([0\u0660][0-9\u0660-\u0669]*)?$/)])
    });
  }

  submit() {
    if (this.form.valid) {
      this.SubmitClient(this.form.value);
    }
    else {
      this.shared.FireFormValidation(this.form);
    }
  }

  SubmitClient(form: any) {
    this.spinner.show();
    const formData = new FormData();

    formData.append('name', form.name);
    formData.append('userName', form.name);
    formData.append('clientPhone', form.clientPhone);
    formData.append('clientTypeId', ClientType.customer.toString());
    formData.append('userType', UserType.Client.toString());

    this.api.CreateNewClient(formData).pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: (data: any) => {
            this.spinner.hide();
            if (data != null) {
              if (data.isSuccess) {
                this.toastrService.showSuccessToast('Success', 'AddedSuccessfully');
                this.dialogRef.close({ data: data?.payload });
              } else {
                this.toastrService.showErrorToast('Error', data.message);
              }
            }
            else {
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          },
          error: (error: any) => {
            this.spinner.hide();
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        });
  }


  onClose(): void {
    this.dialogRef.close();
  }
}
